import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";

import { H2 } from "commons";
import { getFullClientName } from "commons/src/helpers/FormattingHelpers";

function UserDetailsComponent({ isSideBar, currentUser }) {
    return (
        <div>
            <Container isSideBar={isSideBar}>
                <H2 margin="0 0 0.25em" tertiary={!isSideBar} secondary={isSideBar}>
                    {getFullClientName(currentUser)}
                </H2>
                <Ul>
                    <li>
                        Client reference: <br />
                        {currentUser.clientId}
                    </li>
                </Ul>
            </Container>
        </div>
    );
}

const Container = styled.div`
    ${props =>
        !props.isSideBar &&
        `
        color: ${props.theme.tertiary};
        margin: 20px 17px 0 8%;
    `}
`;

const Ul = styled.ul`
    font-size: 1em;
    list-style: none;
`;

UserDetailsComponent.propTypes = {
    currentUser: PropTypes.shape({
        forename: PropTypes.string,
        surname: PropTypes.string,
        clientId: PropTypes.number
    }),
    client: PropTypes.shape({
        username: PropTypes.string,
        credentials: PropTypes.shape({
            clientId: PropTypes.number
        })
    }),
    isSideBar: PropTypes.bool,
    actions: PropTypes.shape({
        hasSeen: PropTypes.func
    })
};

UserDetailsComponent.defaultProps = {
    currentUser: {
        username: "",
        credentials: {
            clientID: 12345
        }
    },
    isSideBar: false
};

const mapStateToProps = state => ({
    currentUser: state.user.currentUser
});

export const UserDetails = connect(mapStateToProps)(UserDetailsComponent);
